export const membershipStatusValues = ['active', 'invited', 'disabled'] as const;
export type CompanyMembershipStatus = (typeof membershipStatusValues)[number];

export type ChangeableMembershipStatus = Exclude<CompanyMembershipStatus, 'invited'>;

export interface CompanyMembershipDto {
  id: string; // UUID
  companyId: string;
  userId: string;
  status: CompanyMembershipStatus;
  createdAt: string; // ISO timestamp
  updatedAt: string; // ISO timestamp
  // Constraint: (companyId, userId) must be unique to prevent duplicate memberships.
}

export interface CompanyMembershipRoleDto {
  roleId: string; // UUID
  roleName: string;
}

export interface CompanyMembershipListItemDto {
  id: string; // UUID
  userId: string; // UUID
  userEmail: string;
  status: CompanyMembershipStatus;
  roles: CompanyMembershipRoleDto[];
  createdAt: string; // ISO timestamp
  updatedAt: string; // ISO timestamp
}

// Membership summary for the current user (company-aware auth context).
export interface CompanyMembershipSummaryDto {
  membershipId: string;
  companyId: string;
  companyName: string;
  status: CompanyMembershipStatus;
}

export interface InviteUserToCompanyRequest {
  companyId: string;
  email: string;
  roleIds: string[];
}

export interface InviteUserToCompanyResponse {
  membership: CompanyMembershipDto;
}

export interface ListMembershipsByCompanyRequest {
  companyId: string;
  status?: CompanyMembershipStatus;
  page?: number;
  pageSize?: number;
}

export interface ListMembershipsByCompanyResponse {
  items: CompanyMembershipListItemDto[];
  page: number;
  pageSize: number;
  total: number;
}

export interface ChangeMembershipStatusRequest {
  companyId: string;
  membershipId: string;
  status: ChangeableMembershipStatus;
}

export interface ChangeMembershipStatusResponse {
  membership: CompanyMembershipDto;
}

export interface GetMembershipRequest {
  companyId: string;
  membershipId: string;
}

export interface GetMembershipResponse {
  membership: CompanyMembershipDto;
}
